export default __webpack_public_path__ + "img/light.ca96fa39.svg";